// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"f4027abe","aiSupportButton":"ee162bb1"};